import _ from "lodash";
import moment from "moment";
import ReportDefinitionModel from "./Model/ReportDefinitionModel";
import scSets from "./SelectionCriteriaSets";
import PeriodSelectionConstants from "./PeriodSelectionConstants";
import * as categoryGroups from "../redux/actions/types/CategoryGroupTypes";
import * as reportCategories from "../redux/actions/types/ReportCategoryTypes";
import * as directionTypes from "../redux/actions/types/DirectionTypes";
import * as reportTypes from "../redux/actions/types/ReportTypes";
import * as locationTypes from "../redux/actions/types/LocationTypes";
import * as productTypes from "../redux/actions/types/ProductTypes";
import apiFetchDespatchParticularsOverview from "../../report/despatch/particulars/overview/api/DespatchParticularsOverviewContainerAPI";
import apiFetchDespatchParticularsReceptacleType from "../../report/despatch/particulars/receptacle-type/api/DespatchParticularsReceptacleTypeAPI";
import apiFetchDespatchParticularsFormatOfContents from "../../report/despatch/particulars/format-of-contents/api/DespatchParticularsFormatOfContentsAPI";
import apiFetchDespatchMonitoringEventTargets from "../../report/despatch/monitoring/event-targets/api/DespatchMonitoringEventTargetsAPI";
import apiFetchDespatchParticularsContent from "../../report/despatch/particulars/content/api/DespatchParticularsContentAPI";
import apiFetchDespatchMonitoringOverview from "../../report/despatch/monitoring/overview/api/DespatchMonitoringOverviewAPI";
import apiFetchDespatchParticularsReceptacleDetails from "../../report/despatch/particulars/receptacle-details/api/DespatchParticularsReceptacleDetailsAPI";
import apiFetchDespatchImpcToImpcPerformance from "../../report/despatch/performance/impc-to-impc/api/DespatchImpcToImpcPerformanceAPI";
import apiFetchDespatchMonitoringResponseAnalysis from "../../report/despatch/monitoring/response-analysis/api/DespatchMonitoringResponseAnalysisAPI";
import apiFetchDespatchPostToPostPerformance from "../../report/despatch/performance/post-to-post/api/DespatchPostToPostPerformanceAPI";
import apiFetchDespatchMonitoringReceptacleDetails from "../../report/despatch/monitoring/receptacle-details/api/DespatchMonitoringReceptacleDetailsAPI";
import apiFetchDespatchMeasurementsDailyEvolution from "../../report/despatch/measurements/daily/evolution/api/DespatchMeasurementsDailyEvolutionAPI";
import apiFetchDespatchMeasurementsHourlyEvolution from "../../report/despatch/measurements/hourly/evolution/api/DespatchMeasurementsHourlyEvolutionAPI";
import apiFetchDespatchMonitoringResponsePerformance from "../../report/despatch/monitoring/response-performance/api/DespatchMonitoringResponsePerformanceAPI";
import apiFetchCompliancePredesResdesOperatorMismatch from "../../report/compliance/mismatch/predes-resdes-operator/api/CompliancePredesResdesOperatorMismatchAPI";
import apiFetchComplianceReceptacleIdVsDespatchIdSubclassMismatch from "../../report/compliance/mismatch/receptacle-id-vs-despatch-id/api/ComplianceReceptacleIdVsDespatchIdSubclassMismatchAPI";
import apiFetchCompliancePredesResdesMailboxMismatch from "../../report/compliance/mismatch/predes-resdes-mailbox/api/CompliancePredesResdesMailboxMismatchAPI";
import apiFetchCompliancePredesResdesDespatchesSummary from "../../report/compliance/despatch/predes-resdes-despatches/api/CompliancePredesResdesDespatchesSummaryAPI";
import apiFetchCompliancePredesResdesDespatchesDetails from "../../report/compliance/despatch/predes-resdes-despatches/api/CompliancePredesResdesDespatchesDetailsAPI";
import apiFetchCompliancePredesDestinationImpcCodeNotRegisteredSummary from "../../report/compliance/predes/destination-impc-code-not-registered/api/CompliancePredesDestinationImpcCodeNotRegisteredSummaryAPI";
import apiFetchCompliancePredesDestinationImpcCodeNotRegisteredDetails from "../../report/compliance/predes/destination-impc-code-not-registered/api/CompliancePredesDestinationImpcCodeNotRegisteredDetailsAPI";
import apiFetchCompliancePredesResdesInterchangeEdiMessage from "../../report/compliance/edi-message/predes-resdes-interchange/api/CompliancePredesResdesInterchangeEdiMessageAPI";
import apiFetchReceptacleMonitoringResponsePerformance from "../../report/compliance/receptacle/monitoring/response-performance/api/ReceptacleMonitoringResponsePerformanceAPI";
import apiFetchReceptacleEventIrregularities from "../../report/compliance/event-irregularities/receptacle-event-irregularities/api/ReceptacleEventIrregularitiesAPI";
import apiFetchIpcBagIsPredesResdesAnalysis from "../../report/compliance/ipc-equipment-pools/predes-resdes-analysis/ipc-bag-is/api/IpcEquipmentPoolsPredesResdesAnalysisIpcBagIsAPI";
import apiFetchIpcTrayIlPredesResdesAnalysis from "../../report/compliance/ipc-equipment-pools/predes-resdes-analysis/ipc-tray-il/api/IpcEquipmentPoolsPredesResdesAnalysisIpcTrayIlAPI";
import apiFetchIpcPalletBoxIbPredesResdesAnalysis from "../../report/compliance/ipc-equipment-pools/predes-resdes-analysis/ipc-pallet-box-ib/api/IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbAPI";
import apiFetchPredesOriginImpcCodeNotRegisteredSummary from "../../report/compliance/predes/origin-impc-code-not-registered/summary/api/PredesOriginImpcCodeNotRegisteredSummaryAPI";
import apiFetchPredesOriginImpcCodeNotRegisteredDetails from "../../report/compliance/predes/origin-impc-code-not-registered/details/api/PredesOriginImpcCodeNotRegisteredDetailsAPI";
import apiFetchOriginImpcOperatorPredesSenderMismatchSummary from "../../report/compliance/mismatch/predes-sender/summary/api/OriginImpcOperatorPredesSenderMismatchSummaryAPI";
import apiFetchOriginImpcOperatorPredesSenderMismatchDetails from "../../report/compliance/mismatch/predes-sender/details/api/OriginImpcOperatorPredesSenderMismatchDetailsAPI";
import apiFetchMultiplePredesSummary from "../../report/compliance/predes/multiple/summary/api/MultiplePredesSummaryAPI";
import apiFetchMultiplePredesDetails from "../../report/compliance/predes/multiple/details/api/MultiplePredesDetailsAPI";
import apiFetchReceptaclesPredesResdesAnalysis from "../../report/compliance/ipc-equipment-pools/predes-resdes-analysis/receptacles/api/IpcEquipmentPoolsPredesResdesAnalysisReceptaclesAPI";
import apiFetchComplianceResconConsignmentIdNotInPreconSummary from "../../report/compliance/rescon/consignment-id-not-in-precon/api/ComplianceResconConsignmentIdNotInPreconSummaryAPI";
import apiFetchComplianceResconConsignmentIdNotInPreconDetails from "../../report/compliance/rescon/consignment-id-not-in-precon/api/ComplianceResconConsignmentIdNotInPreconDetailsAPI";
import apiFetchItemsHandoverDataAirSummary from "../../report/kpi/item-handover-data-air/summary/api/ItemsHandoverDataAirSummaryAPI";
import apiFetchItemsHandoverDataAirDetails from "../../report/kpi/item-handover-data-air/details/api/ItemsHandoverDataAirDetailsAPI";
import apiFetchPredesComplianceIncorrectLocationCodeUsageSummary from "../../report/compliance/predes/incorrect-location-code-usage/api/PredesComplianceIncorrectLocationCodeUsageSummaryAPI";
import apiFetchPredesComplianceIncorrectLocationCodeUsageDetails from "../../report/compliance/predes/incorrect-location-code-usage/api/PredesComplianceIncorrectLocationCodeUsageDetailsAPI";
import apiFetchPredesComplianceGapsInDespatchNumbers from "../../report/compliance/predes/gaps-in-despatch-numbers/api/PredesComplianceGapsInDespatchNumbersAPI";
import apiFetchItemsHandoverDataRoadSummary from "../../report/kpi/item-handover-data-road/summary/api/ItemsWithHandoverDataRoadSummaryAPI";
import apiFetchItemsHandoverDataRoadDetails from "../../report/kpi/item-handover-data-road/details/api/ItemsWithHandoverDataRoadDetailsAPI";
import apiFetchPredesImpcCodeUsageNonComplianceSummary from "../../report/edi-compliance/predes/impc-code-usage-non-compliance/summary/api/PredesImpcCodeUsageNonComplianceSummaryAPI";
import apiFetchPredesImpcCodeUsageNonComplianceDetails from "../../report/edi-compliance/predes/impc-code-usage-non-compliance/details/api/PredesImpcCodeUsageNonComplianceDetailsAPI";
import apiFetchPredesPlannedTransportAnomaliesOriginSummary from "../../report/irregularities/predes/planned-transport-anomalies-origin/summary/api/PredesPlannedTransportAnomaliesOriginSummaryAPI";
import apiFetchPredesPlannedTransportAnomaliesOriginDetails from "../../report/irregularities/predes/planned-transport-anomalies-origin/details/api/PredesPlannedTransportAnomaliesOriginDetailsAPI";
import apiFetchPredesPlannedTransportAnomaliesDestinationSummary from "../../report/irregularities/predes/planned-transport-anomalies-destination/summary/api/PredesPlannedTransportAnomaliesDestinationSummaryAPI";
import apiFetchPredesPlannedTransportAnomaliesDestinationDetails from "../../report/irregularities/predes/planned-transport-anomalies-destination/details/api/PredesPlannedTransportAnomaliesDestinationDetailsAPI";
import apiFetchTrackedItemsInPredesSummary from "../../report/kpi/tracked-items-in-predes/api/TrackedItemsInPredesSummaryAPI";
import apiFetchTrackedItemsInPredesDetails from "../../report/kpi/tracked-items-in-predes/api/TrackedItemsInPredesDetailsAPI";
import apiFetchPredesTimelinessSummary from "../../report/edi-messages/predes/timeliness/summary/api/PredesTimelinessSummaryAPI";
import apiFetchPredesTimelinessDetails from "../../report/edi-messages/predes/timeliness/details/api/PredesTimelinessDetailsAPI";
import apiFetchPredesComplianceMissingRequiredElementsSummary from "../../report/edi-messages/predes/compliance/missing-required-elements/summary/api/PredesComplianceMissingRequiredElementsSummaryAPI";
import apiFetchPredesComplianceMissingRequiredElementsDetails from "../../report/edi-messages/predes/compliance/missing-required-elements/details/api/PredesComplianceMissingRequiredElementsDetailsAPI";
import apiFetchPredesCompliance from "../../report/edi-compliance/predes/compliance/api/PredesComplianceAPI";
import apiFetchReceptaclesInPreconNotInPredesSummary from "../../report/kpi/receptacles-in-precon-not-in-predes/summary/api/ReceptaclesInPreconNotInPredesSummaryAPI";
import apiFetchReceptaclesInPreconNotInPredesDetails from "../../report/kpi/receptacles-in-precon-not-in-predes/details/api/ReceptaclesInPreconNotInPredesDetailsAPI";
import apiFetchReceptaclesInPredesNotInPreconSummary from "../../report/kpi/receptacles-in-predes-not-in-precon/summary/api/ReceptaclesInPredesNotInPreconSummaryAPI";
import apiFetchReceptaclesInPredesNotInPreconDetails from "../../report/kpi/receptacles-in-predes-not-in-precon/details/api/ReceptaclesInPredesNotInPreconDetailsAPI";
import apiFetchPredesComplianceMissingMandatoryElementsSummary from "../../report/edi-compliance/predes/missing-mandatory-elements/summary/api/PredesComplianceMissingMandatoryElementsSummaryAPI";
import apiFetchPredesComplianceMissingMandatoryElementsErrorMessages from "../../report/edi-compliance/predes/missing-mandatory-elements/error-messages/api/PredesComplianceMissingMandatoryElementsErrorMessagesAPI";
import apiFetchPredesComplianceMissingMandatoryElementsKeyDetails from "../../report/edi-compliance/predes/missing-mandatory-elements/key-details/api/PredesComplianceMissingMandatoryElementsKeyDetailsAPI";
import apiFetchPredesComplianceMessageMappingErrorsSummary from "../../report/edi-compliance/predes/message-mapping-errors/summary/api/PredesComplianceMessageMappingErrorsSummaryAPI";
import apiFetchPredesComplianceMessageMappingErrorsErrorMessages from "../../report/edi-compliance/predes/message-mapping-errors/error-messages/api/PredesComplianceMessageMappingErrorsErrorMessagesAPI";
import apiFetchPredesComplianceMessageMappingErrorsKeyDetails from "../../report/edi-compliance/predes/message-mapping-errors/key-details/api/PredesComplianceMessageMappingErrorsKeyDetailsAPI";
import apiFetchReceptaclesInPredesNotInCarditSummary from "../../report/kpi/receptacles-in-predes-not-in-cardit/summary/api/ReceptaclesInPredesNotInCarditSummaryAPI";
import apiFetchReceptaclesInPredesNotInCarditDetails from "../../report/kpi/receptacles-in-predes-not-in-cardit/details/api/ReceptaclesInPredesNotInCarditDetailsAPI";
import apiFetchInterchangeDetails from "../../report/edi-messages/interchange-details/api/InterchangeDetailsAPI";
import apiFetchPreconResconConsignmentsSummary from "../../report/irregularities/precon-rescon-consignments/api/PreconResconConsignmentsSummaryAPI";
import apiFetchPreconResconConsignmentsDetails from "../../report/irregularities/precon-rescon-consignments/api/PreconResconConsignmentsDetailsAPI";
import apiFetchInterchangeProcessingSummary from "../../report/edi-messages/interchange-processing/summary/api/InterchangeProcessingSummaryAPI";
import apiFetchInterchangeProcessingDetails from "../../report/edi-messages/interchange-processing/details/api/InterchangeProcessingDetailsAPI";
import apiFetchIntrefSequenceVerification from "../../report/edi-compliance/intref/intref-sequence-verification/api/IntrefSequenceVerificationAPI";
import apiFetchCarditResditInterchanges from "../../report/edi-messages/cardit-resdit-interchanges/api/CarditResditInterchangesAPI";
import apiFetchConsignmentResponseAnalysis from "../../report/consignment/response-analysis/api/ConsignmentResponseAnalysisAPI";
import apiFetchConsignmentParticulars from "../../report/consignment/particulars/api/ConsignmentParticularsAPI";
import apiFetchConsignmentReceptacleDetails from "../../report/consignment/receptacle-details/api/ConsignmentReceptacleDetailsAPI";
import apiFetchMrdXmlAnalysis from "../../report/mrd/xml-analysis/api/MrdXmlAnalysisAPI";
import apiFetchHandoverRegistrationAtOrigin from "../../report/mrd/handover-registration-at-origin/api/HandoverRegistrationAtOriginAPI";
import apiFetchOperationalAnalysis from "../../report/mrd/operational-analysis/api/OperationalAnalysisAPI";
import apiFetchOperationalAnalysisDaily from "../../report/mrd/operational-analysis/daily/api/OperationalAnalysisDailyAPI";
import apiFetchMrdPodOverview from "../../report/mrd/pod-overview/api/MrdPodOverviewAPI";
import apiFetchMrdXmlDailyAnalysis from "../../report/mrd/xml-daily-analysis/api/MrdXmlDailyAnalysisAPI";
import apiFetchCarditCriticalElementsCarrier from "../../report/consignment/cardit-critical-elements/carrier/api/CarditCriticalElementsCarrierAPI";
import apiFetchCarditCriticalElementsLocation from "../../report/consignment/cardit-critical-elements/location/api/CarditCriticalElementsLocationAPI";
import apiFetchCarditCriticalElementsDetails from "../../report/consignment/cardit-critical-elements/details/api/CarditCriticalElementsDetailsAPI";
import apiFetchCarditNestingCarrier from "../../report/consignment/cardit-nesting/carrier/api/CarditNestingCarrierAPI";
import apiFetchCarditNestingLocation from "../../report/consignment/cardit-nesting/location/api/CarditNestingLocationAPI";
import apiFetchCarditNestingDetails from "../../report/consignment/cardit-nesting/details/api/CarditNestingDetailsAPI";
import apiFetchSaintPierreEtMiquelonSummary from "../../report/consignment/saint-pierre-et-miquelon/summary/api/SaintPierreEtMiquelonSummaryAPI";
import apiFetchSaintPierreEtMiquelonDetails from "../../report/consignment/saint-pierre-et-miquelon/details/api/SaintPierreEtMiquelonDetailsAPI";
import apiFetchCarditResditBestPracticeElements from "../../report/consignment/cardit-resdit-best-practice-elements/api/CarditResditBestPracticeElementsAPI";
import apiFetchResdit7421PerformanceCarrier from "../../report/consignment/resdit-74-21-performance/carrier/api/Resdit7421PerformanceCarrierAPI";
import apiFetchResdit7421PerformanceLocation from "../../report/consignment/resdit-74-21-performance/location/api/Resdit7421PerformanceLocationAPI";
import apiFetchResdit7421PerformanceDetails from "../../report/consignment/resdit-74-21-performance/details/api/Resdit7421PerformanceDetailsAPI";
import apiFetchCarrierResdit7421PerformanceOperator from "../../report/carrier/resdit-74-21-performance/operator/api/CarrierResdit7421PerformanceOperatorAPI";
import apiFetchCarrierResdit7421PerformanceLocation from "../../report/carrier/resdit-74-21-performance/location/api/CarrierResdit7421PerformanceLocationAPI";
import apiFetchCarrierResdit7421PerformanceDetails from "../../report/carrier/resdit-74-21-performance/details/api/CarrierResdit7421PerformanceDetailsAPI";
import apiFetchCarrierNestingOperator from "../../report/carrier/nesting/operator/api/CarrierNestingOperatorAPI";
import apiFetchCarrierNestingLocation from "../../report/carrier/nesting/location/api/CarrierNestingLocationAPI";
import apiFetchCarrierNestingDetails from "../../report/carrier/nesting/details/api/CarrierNestingDetailsAPI";
import apiFetchCarditTimelinessAnalysis from "../../report/consignment/cardit-timeliness-analysis/api/CarditTimelinessAnalysisAPI";
import apiFetchCarrierM39ComplianceOperator from "../../report/carrier/m39-compliance/operator/api/CarrierM39ComplianceOperatorAPI";
import apiFetchCarrierM39ComplianceLocation from "../../report/carrier/m39-compliance/location/api/CarrierM39ComplianceLocationAPI";
import apiFetchCarrierM39ComplianceDetails from "../../report/carrier/m39-compliance/details/api/CarrierM39ComplianceDetailsAPI";
import apiFetchCarrierMailRegistrationDeviceDeliverySummary from "../../report/handler/carrier-mail-registration-device-delivery/summary/api/CarrierMailRegistrationDeviceDeliverySummaryAPI";
import apiFetchCarrierMailRegistrationDeviceDeliveryCarrierPerformance from "../../report/handler/carrier-mail-registration-device-delivery/carrier-performance/api/CarrierMailRegistrationDeviceDeliveryCarrierPerformanceAPI";
import apiFetchCarrierMailRegistrationDeviceDeliveryDetails from "../../report/handler/carrier-mail-registration-device-delivery/details/api/CarrierMailRegistrationDeviceDeliveryDetailsAPI";
import apiFetchCarrierCarditResditBestPracticeElements from "../../report/carrier/cardit-resdit-best-practice-elements/api/CarrierCarditResditBestPracticeElementsAPI";
import apiFetchHandlerMailRegistrationDeviceDeliverySummary from "../../report/carrier/handler-registration-device-delivery/summary/api/HandlerMailRegistrationDeviceDeliverySummaryAPI";
import apiFetchHandlerMailRegistrationDeviceDeliveryCarrierPerformance from "../../report/carrier/handler-registration-device-delivery/carrier-performance/api/HandlerMailRegistrationDeviceDeliveryCarrierPerformanceAPI";
import apiFetchHandlerMailRegistrationDeviceDeliveryDetails from "../../report/carrier/handler-registration-device-delivery/details/api/HandlerMailRegistrationDeviceDeliveryDetailsAPI";
import apiFetchCarditByReceivingAirline from "../../report/edi-exchange-overview/cardit-by-receiving-airline/api/CarditByReceivingAirlineAPI";
import apiFetchCarditByReceivingAirlineNumbered from "../../report/edi-exchange-overview/cardit-by-receiving-airline/api/CarditByReceivingAirlineNumberedAPI";
import apiFetchCarditBySendingPostSigned from "../../report/edi-exchange-overview/cardit-by-sending-post/api/CarditBySendingPostSignedAPI";
import apiFetchCarditBySendingPostNumbered from "../../report/edi-exchange-overview/cardit-by-sending-post/api/CarditBySendingPostNumberedAPI";
import apiFetchResditByReceivingPostSigned from "../../report/edi-exchange-overview/resdit-by-receiving-post/api/ResditByReceivingPostSignedAPI";
import apiFetchResditByReceivingPostNumbered from "../../report/edi-exchange-overview/resdit-by-receiving-post/api/ResditByReceivingPostNumberedAPI";
import apiFetchResditBySendingAirline from "../../report/edi-exchange-overview/resdit-by-sending-airline/api/ResditBySendingAirlineAPI";
import apiFetchResditBySendingAirlineNumbered from "../../report/edi-exchange-overview/resdit-by-sending-airline/api/ResditBySendingAirlineNumberedAPI";
import apiFetchTransportExceptions from "../../report/despatch/transport-exceptions/api/TransportExceptionsAPI";
import apiFetchReceptacleTransportOverview from "../../report/monitoring/receptacle/transport-overview/api/ReceptacleTransportOverviewAPI";
import apiFetchReceptacleOverview from "../../report/monitoring/receptacle/overview/api/ReceptacleOverviewAPI";
import apiFetchCarditLinkTrace from "../../report/cardit/cardit-link-trace/api/CarditLinkTraceAPI";
import apiFetchHandlerMonitoring from "../../report/mrd/handler-monitoring/api/HandlerMonitoringAPI";
import apiFetchCarrierAnalysis from "../../report/mrd/carrier-analysis/api/CarrierAnalysisAPI";
import apiFetchCarditResditEventOverview from "../../report/consignment/cardit-resdit-event-overview/api/CarditResditEventOverviewAPI";
import apiFetchPaperFreeMonitoringPostSummary from "../../report/paper-free/monitoring-post/api/PaperFreeMonitoringPostSummaryAPI";
import apiFetchPaperFreeMonitoringPostDetails from "../../report/paper-free/monitoring-post/api/PaperFreeMonitoringPostDetailsAPI";
import apiFetchResdesManagementSummaryEpg from "../../report/epg/resdes-management-summary/api/ResdesManagementSummaryEpgAPI";
import apiFetchPaperFreeMonitoringCarrierSummary from "../../report/paper-free/monitoring-carrier/summary/api/PaperFreeMonitoringCarrierSummaryAPI";
import apiFetchPaperFreeMonitoringCarrierDetails from "../../report/paper-free/monitoring-carrier/details/api/PaperFreeMonitoringCarrierDetailsAPI";
import apiFetchCarrierPaperFreeMonitoringSummary from "../../report/carrier/paper-free-monitoring-carrier/summary/api/CarrierPaperFreeMonitoringSummaryAPI";
import apiFetchCarrierPaperFreeMonitoringDetails from "../../report/carrier/paper-free-monitoring-carrier/details/api/CarrierPaperFreeMonitoringDetailsAPI";
import apiFetchCarrierPaperFreeMonitoringPostSummary from "../../report/carrier/paper-free-monitoring-post/summary/api/PaperFreeMonitoringPostSummaryAPI";
import apiFetchCarrierPaperFreeMonitoringPostDetails from "../../report/carrier/paper-free-monitoring-post/details/api/PaperFreeMonitoringPostDetailsAPI";
import apiFetchEpgLinkByLink from "../../report/epg/link-by-link-report/api/EpgLinkByLinkAPI";
import apiFetchHandoverAnalysisAtDestination from "../../report/consignment/handover-analysis-destination/api/HandoverAnalysisAtDestinationAPI";
import apiFetchMessageCapabilityOverview from "../../report/edi-exchange/message-capability-overview/api/MessageCapabilityOverviewAPI";
import apiFetchMessageProfile from "../../report/edi-exchange/message-profile/api/MessageProfileAPI";
import apiFetchEdiExchangeLetter from "../../report/edi-exchange/predes-v21-overview/letter/api/EdiExchangeLetterAPI";
import apiFetchEdiExchangeParcel from "../../report/edi-exchange/predes-v21-overview/parcel/api/EdiExchangeParcelAPI";
import apiFetchEdiExchangeEms from "../../report/edi-exchange/predes-v21-overview/ems/api/EdiExchangeEmsAPI";
import apiFetchIpcTrayUsage from "../../report/amt-reports/tray-usage-report/api/IpcTrayUsageAPI";
import apiFetchMixedTrayUsage from "../../report/amt-reports/mixed-tray-usage-report/api/MixedTrayUsageAPI";
import apiFetchBagUsage from "../../report/amt-reports/bag-usage-report/api/BagUsageAPI";
import apiFetchPalletBoxUsage from "../../report/amt-reports/pallet-box-usage-report/api/PalletBoxUsageAPI";
import apiFetchComparativeTrayUsage from "../../report/amt-reports/comparative-tray-usage-report/api/ComparativeTrayUsageAPI";
import apiFetchComparativeBagUsage from "../../report/amt-reports/comparative-bag-usage-report/api/ComparativeBagUsageAPI";
import apiFetchComparativePalletBoxUsage from "../../report/amt-reports/comparative-pallet-box-usage-report/api/ComparativePalletBoxUsageAPI";
import apiFetchReceptaclePodPerformanceSummary from "../../report/mrd/receptacle-pod-performance/summary/api/ReceptaclePodPerformanceSummaryAPI";
import apiFetchReceptaclePodPerformanceDetails from "../../report/mrd/receptacle-pod-performance/details/api/ReceptaclePodPerformanceDetailsAPI";
import apiFetchCapeUsageMonitoring from "../../report/user-monitoring/cape-usage-monitoring/monitoring/api/CapeUsageMonitoringAPI";
import apiFetchCapeUsageMonitoringByOperator from "../../report/user-monitoring/cape-usage-monitoring/monitoring-by-operator/api/CapeUsageMonitoringByOperatorAPI";
import apiFetchCapeUsageMonitoringByUser from "../../report/user-monitoring/cape-usage-monitoring/monitoring-by-user/api/CapeUsageMonitoringByUserAPI";
import apiFetchItemOverviewV1 from "../../report/item/item-overview/v1/api/ItemOverviewV1API";
import apiFetchItemOverviewV2 from "../../report/item/item-overview/v2/api/ItemOverviewV2API";
import apiFetchItemOverviewDetails from "../../report/item/item-overview/details/api/ItemOverviewDetails200API";
import apiFetchThresholdsForCertificationDetails from "../../report/certification/thresholds-for-certification/details/api/ThresholdsForCertificationDetailsAPI";
import apiFetchThresholdsForCertificationSummary from "../../report/certification/thresholds-for-certification/summary/api/ThresholdsForCertificationSummaryAPI";

function formatDurations(data) {
  return _.map(data, (dataRow) => {
    const resdesTail = moment.duration(dataRow.resdesTail);

    return {
      ...dataRow,
      resdesTail: `${Math.trunc(resdesTail.asHours())}:${resdesTail.minutes()}`,
    };
  });
}

class ReportDefinitions {
  defaults;

  constructor() {
    this.defaults = {
      DESPATCH_PARTICULARS_OVERVIEW: new ReportDefinitionModel(
        "DESPATCH_PARTICULARS_OVERVIEW",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchParticularsPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchParticularsOverview
      ),
      DESPATCH_PARTICULARS_RECEPTACLE_TYPE: new ReportDefinitionModel(
        "DESPATCH_PARTICULARS_RECEPTACLE_TYPE",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchParticularsPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchParticularsReceptacleType
      ),
      DESPATCH_PARTICULARS_FORMAT_OF_CONTENTS: new ReportDefinitionModel(
        "DESPATCH_PARTICULARS_FORMAT_OF_CONTENTS",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchParticularsPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchParticularsFormatOfContents
      ),
      DESPATCH_PARTICULARS_CONTENT: new ReportDefinitionModel(
        "DESPATCH_PARTICULARS_CONTENT",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchParticularsPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchParticularsContent
      ),
      DESPATCH_PARTICULARS_RECEPTACLE_DETAILS: new ReportDefinitionModel(
        "DESPATCH_PARTICULARS_RECEPTACLE_DETAILS",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchParticularsPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchParticularsReceptacleDetails
      ),
      IMPC_TO_IMPC_DESPATCH_PERFORMANCE: new ReportDefinitionModel(
        "IMPC_TO_IMPC_DESPATCH_PERFORMANCE",
        reportTypes.A,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchPerformancePeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchImpcToImpcPerformance
      ),
      POST_TO_POST_DESPATCH_PERFORMANCE: new ReportDefinitionModel(
        "POST_TO_POST_DESPATCH_PERFORMANCE",
        reportTypes.A,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchPerformancePeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchPostToPostPerformance
      ),
      DESPATCH_MONITORING_OVERVIEW: new ReportDefinitionModel(
        "DESPATCH_MONITORING_OVERVIEW",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchMonitoringPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchMonitoringOverview
      ),
      DESPATCH_MONITORING_RESPONSE_PERFORMANCE: new ReportDefinitionModel(
        "DESPATCH_MONITORING_RESPONSE_PERFORMANCE",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchMonitoringPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchMonitoringResponsePerformance
      ),
      DESPATCH_MONITORING_RESPONSE_ANALYSIS: new ReportDefinitionModel(
        "DESPATCH_MONITORING_RESPONSE_ANALYSIS",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchMonitoringPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchMonitoringResponseAnalysis
      ),
      DESPATCH_MONITORING_EVENT_TARGETS: new ReportDefinitionModel(
        "DESPATCH_MONITORING_EVENT_TARGETS",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchMonitoringPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchMonitoringEventTargets,
        formatDurations
      ),
      DESPATCH_MONITORING_RECEPTACLE_DETAILS: new ReportDefinitionModel(
        "DESPATCH_MONITORING_RECEPTACLE_DETAILS",
        reportTypes.E,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchMonitoringPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchMonitoringReceptacleDetails
      ),
      DESPATCH_MEASUREMENTS_DAILY_EVOLUTION: new ReportDefinitionModel(
        "DESPATCH_MEASUREMENTS_DAILY_EVOLUTION",
        reportTypes.A,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchMeasurementsDailyEvolutionPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchMeasurementsDailyEvolution
      ),
      DESPATCH_MEASUREMENTS_HOURLY_EVOLUTION: new ReportDefinitionModel(
        "DESPATCH_MEASUREMENTS_HOURLY_EVOLUTION",
        reportTypes.A,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchMeasurementsHourlyEvolutionPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchDespatchMeasurementsHourlyEvolution
      ),
      PREDES_RESDES_MAILBOX_MISMATCH: new ReportDefinitionModel(
        "PREDES_RESDES_MAILBOX_MISMATCH",
        reportTypes.A,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchCompliancePredesResdesMailboxMismatch
      ),
      PREDES_RESDES_OPERATOR_MISMATCH: new ReportDefinitionModel(
        "PREDES_RESDES_OPERATOR_MISMATCH",
        reportTypes.A,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchCompliancePredesResdesOperatorMismatch
      ),
      MISMATCHED_SUBCLASS_RECEPTACLE_ID_VS_DESPATCH_ID:
        new ReportDefinitionModel(
          "MISMATCHED_SUBCLASS_RECEPTACLE_ID_VS_DESPATCH_ID",
          reportTypes.A,
          categoryGroups.COMPLIANCE_EXCEPTION_SC,
          reportCategories.COMPLIANCE,
          [directionTypes.INBOUND, directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchComplianceReceptacleIdVsDespatchIdSubclassMismatch
        ),
      PREDES_RESDES_DESPATCHES_SUMMARY: new ReportDefinitionModel(
        "PREDES_RESDES_DESPATCHES_SUMMARY",
        reportTypes.B,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchCompliancePredesResdesDespatchesSummary
      ),
      PREDES_RESDES_DESPATCHES_DETAILS: new ReportDefinitionModel(
        "PREDES_RESDES_DESPATCHES_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchCompliancePredesResdesDespatchesDetails
      ),
      PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY:
        new ReportDefinitionModel(
          "PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY",
          reportTypes.B,
          categoryGroups.COMPLIANCE_EXCEPTION_SC,
          reportCategories.COMPLIANCE,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_11NA_30,
          apiFetchCompliancePredesDestinationImpcCodeNotRegisteredSummary
        ),
      PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_DETAILS:
        new ReportDefinitionModel(
          "PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_DETAILS",
          reportTypes.B,
          categoryGroups.NO_GROUP,
          reportCategories.COMPLIANCE,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_11NA_30,
          apiFetchCompliancePredesDestinationImpcCodeNotRegisteredDetails
        ),
      PREDES_AND_RESDES_INTERCHANGES: new ReportDefinitionModel(
        "PREDES_AND_RESDES_INTERCHANGES",
        reportTypes.A,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.EDI_MESSAGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchCompliancePredesResdesInterchangeEdiMessage
      ),
      RECEPTACLE_MONITORING_RESPONSE_PERFORMANCE: new ReportDefinitionModel(
        "RECEPTACLE_MONITORING_RESPONSE_PERFORMANCE",
        reportTypes.A,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.receptacleMonitoring,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptacleMonitoringResponsePerformance
      ),
      RECEPTACLE_EVENT_IRREGULARITIES: new ReportDefinitionModel(
        "RECEPTACLE_EVENT_IRREGULARITIES",
        reportTypes.A,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptacleEventIrregularities
      ),
      IPC_BAG_IS_PREDES_RESDES_ANALYSIS: new ReportDefinitionModel(
        "IPC_BAG_IS_PREDES_RESDES_ANALYSIS",
        reportTypes.C,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchIpcBagIsPredesResdesAnalysis
      ),
      IPC_TRAY_IL_PREDES_RESDES_ANALYSIS: new ReportDefinitionModel(
        "IPC_TRAY_IL_PREDES_RESDES_ANALYSIS",
        reportTypes.C,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchIpcTrayIlPredesResdesAnalysis
      ),
      IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS: new ReportDefinitionModel(
        "IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS",
        reportTypes.C,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchIpcPalletBoxIbPredesResdesAnalysis
      ),
      ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_SUMMARY:
        new ReportDefinitionModel(
          "ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_SUMMARY",
          reportTypes.B,
          categoryGroups.COMPLIANCE_EXCEPTION_SC,
          reportCategories.COMPLIANCE,
          [directionTypes.INBOUND, directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchOriginImpcOperatorPredesSenderMismatchSummary
        ),
      PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_SUMMARY: new ReportDefinitionModel(
        "PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_SUMMARY",
        reportTypes.B,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchPredesOriginImpcCodeNotRegisteredSummary
      ),
      PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_DETAILS: new ReportDefinitionModel(
        "PREDES_ORIGIN_IMPC_CODE_NOT_REGISTERED_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchPredesOriginImpcCodeNotRegisteredDetails
      ),
      ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_DETAILS:
        new ReportDefinitionModel(
          "ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_DETAILS",
          reportTypes.B,
          categoryGroups.NO_GROUP,
          reportCategories.COMPLIANCE,
          [directionTypes.INBOUND, directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchOriginImpcOperatorPredesSenderMismatchDetails
        ),
      MULTIPLE_PREDES_SUMMARY: new ReportDefinitionModel(
        "MULTIPLE_PREDES_SUMMARY",
        reportTypes.B,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchMultiplePredesSummary
      ),
      MULTIPLE_PREDES_DETAILS: new ReportDefinitionModel(
        "MULTIPLE_PREDES_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchMultiplePredesDetails
      ),
      RECEPTACLES_PREDES_RESDES_ANALYSIS: new ReportDefinitionModel(
        "RECEPTACLES_PREDES_RESDES_ANALYSIS",
        reportTypes.C,
        categoryGroups.NO_GROUP,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptaclesPredesResdesAnalysis
      ),
      RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_SUMMARY: new ReportDefinitionModel(
        "RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_SUMMARY",
        reportTypes.B,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.interchangePreparationWithAllPickers,
        scSets.SC_1_2_3_11_30,
        apiFetchComplianceResconConsignmentIdNotInPreconSummary
      ),
      RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_DETAILS: new ReportDefinitionModel(
        "RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.interchangePreparationWithAllPickers,
        scSets.SC_1_2_3_11_30,
        apiFetchComplianceResconConsignmentIdNotInPreconDetails
      ),
      ITEMS_WITH_HANDOVER_DATA_AIR_SUMMARY: new ReportDefinitionModel(
        "ITEMS_WITH_HANDOVER_DATA_AIR_SUMMARY",
        reportTypes.B,
        categoryGroups.KIP,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchItemsHandoverDataAirSummary
      ),
      ITEMS_WITH_HANDOVER_DATA_AIR_DETAILS: new ReportDefinitionModel(
        "ITEMS_WITH_HANDOVER_DATA_AIR_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchItemsHandoverDataAirDetails
      ),
      PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_SUMMARY:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_SUMMARY",
          reportTypes.B,
          categoryGroups.COMPLIANCE_EXCEPTION_SC,
          reportCategories.COMPLIANCE,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceIncorrectLocationCodeUsageSummary
        ),
      PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_DETAILS:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_DETAILS",
          reportTypes.B,
          categoryGroups.NO_GROUP,
          reportCategories.COMPLIANCE,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceIncorrectLocationCodeUsageDetails
        ),
      PREDES_COMPLIANCE_GAPS_IN_DESPATCH_NUMBERS: new ReportDefinitionModel(
        "PREDES_COMPLIANCE_GAPS_IN_DESPATCH_NUMBERS",
        reportTypes.A,
        categoryGroups.COMPLIANCE_EXCEPTION_SC,
        reportCategories.COMPLIANCE,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchPredesComplianceGapsInDespatchNumbers
      ),
      ITEMS_WITH_HANDOVER_DATA_ROAD_SUMMARY: new ReportDefinitionModel(
        "ITEMS_WITH_HANDOVER_DATA_ROAD_SUMMARY",
        reportTypes.B,
        categoryGroups.KPI,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchItemsHandoverDataRoadSummary
      ),
      ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS: new ReportDefinitionModel(
        "ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchItemsHandoverDataRoadDetails
      ),
      PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY: new ReportDefinitionModel(
        "PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY",
        reportTypes.B,
        categoryGroups.EDI_COMPLIANCE,
        reportCategories.PREDES,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchPredesImpcCodeUsageNonComplianceSummary
      ),
      PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS: new ReportDefinitionModel(
        "PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.PREDES,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchPredesImpcCodeUsageNonComplianceDetails
      ),
      PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_SUMMARY:
        new ReportDefinitionModel(
          "PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_SUMMARY",
          reportTypes.B,
          categoryGroups.IRREGULARITIES,
          reportCategories.PREDES,
          [directionTypes.INBOUND, directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.receptacleMonitoring,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesPlannedTransportAnomaliesOriginSummary
        ),
      PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_DETAILS:
        new ReportDefinitionModel(
          "PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_DETAILS",
          reportTypes.B,
          categoryGroups.NO_GROUP,
          reportCategories.PREDES,
          [directionTypes.INBOUND, directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.receptacleMonitoring,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesPlannedTransportAnomaliesOriginDetails
        ),
      PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_SUMMARY:
        new ReportDefinitionModel(
          "PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_SUMMARY",
          reportTypes.B,
          categoryGroups.IRREGULARITIES,
          reportCategories.PREDES,
          [directionTypes.INBOUND, directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.receptacleMonitoring,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesPlannedTransportAnomaliesDestinationSummary
        ),
      PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_DETAILS:
        new ReportDefinitionModel(
          "PREDES_PLANNED_TRANSPORT_ANOMALIES_DESTINATION_DETAILS",
          reportTypes.B,
          categoryGroups.NO_GROUP,
          reportCategories.PREDES,
          [directionTypes.INBOUND, directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.receptacleMonitoring,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesPlannedTransportAnomaliesDestinationDetails
        ),
      TRACKED_ITEMS_IN_PREDES_SUMMARY: new ReportDefinitionModel(
        "TRACKED_ITEMS_IN_PREDES_SUMMARY",
        reportTypes.B,
        categoryGroups.KPI,
        reportCategories.PREDES,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_11_TRACKED_ITEMS_IN_PREDES,
        apiFetchTrackedItemsInPredesSummary
      ),
      TRACKED_ITEMS_IN_PREDES_DETAILS: new ReportDefinitionModel(
        "TRACKED_ITEMS_IN_PREDES_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.PREDES,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_11_TRACKED_ITEMS_IN_PREDES,
        apiFetchTrackedItemsInPredesDetails
      ),
      PREDES_TIMELINESS_SUMMARY: new ReportDefinitionModel(
        "PREDES_TIMELINESS_SUMMARY",
        reportTypes.B,
        categoryGroups.EDI_MESSAGES,
        reportCategories.PREDES,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchPredesTimelinessSummary
      ),
      PREDES_TIMELINESS_DETAILS: new ReportDefinitionModel(
        "PREDES_TIMELINESS_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.PREDES,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchPredesTimelinessDetails
      ),
      PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY",
          reportTypes.B,
          categoryGroups.EDI_MESSAGES,
          reportCategories.PREDES,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceMissingRequiredElementsSummary
        ),
      PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_DETAILS:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_DETAILS",
          reportTypes.B,
          categoryGroups.NO_GROUP,
          reportCategories.PREDES,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceMissingRequiredElementsDetails
        ),
      PREDES_COMPLIANCE: new ReportDefinitionModel(
        "PREDES_COMPLIANCE",
        reportTypes.A,
        categoryGroups.EDI_COMPLIANCE,
        reportCategories.PREDES,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchPredesCompliance
      ),
      RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY: new ReportDefinitionModel(
        "RECEPTACLES_IN_PRECON_NOT_IN_PREDES_SUMMARY",
        reportTypes.B,
        categoryGroups.KPI,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptaclesInPreconNotInPredesSummary
      ),
      RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS: new ReportDefinitionModel(
        "RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptaclesInPreconNotInPredesDetails
      ),
      RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY: new ReportDefinitionModel(
        "RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY",
        reportTypes.B,
        categoryGroups.KPI,
        reportCategories.RECEPTACLE,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptaclesInPredesNotInPreconSummary
      ),
      RECEPTACLES_IN_PREDES_NOT_IN_PRECON_DETAILS: new ReportDefinitionModel(
        "RECEPTACLES_IN_PREDES_NOT_IN_PRECON_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.RECEPTACLE,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptaclesInPredesNotInPreconDetails
      ),
      PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY",
          reportTypes.D,
          categoryGroups.EDI_COMPLIANCE,
          reportCategories.PREDES,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceMissingMandatoryElementsSummary
        ),
      PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES",
          reportTypes.D,
          categoryGroups.NO_GROUP,
          reportCategories.PREDES,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceMissingMandatoryElementsErrorMessages
        ),
      PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS",
          reportTypes.D,
          categoryGroups.NO_GROUP,
          reportCategories.PREDES,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceMissingMandatoryElementsKeyDetails
        ),
      PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_SUMMARY:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_SUMMARY",
          reportTypes.D,
          categoryGroups.EDI_COMPLIANCE,
          reportCategories.PREDES,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceMessageMappingErrorsSummary
        ),
      PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES",
          reportTypes.D,
          categoryGroups.NO_GROUP,
          reportCategories.PREDES,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceMessageMappingErrorsErrorMessages
        ),
      PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_KEY_DETAILS:
        new ReportDefinitionModel(
          "PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_KEY_DETAILS",
          reportTypes.D,
          categoryGroups.NO_GROUP,
          reportCategories.PREDES,
          [directionTypes.OUTBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.complianceMismatchPeriod,
          scSets.SC_1_2_3_10_30,
          apiFetchPredesComplianceMessageMappingErrorsKeyDetails
        ),
      RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY: new ReportDefinitionModel(
        "RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY",
        reportTypes.B,
        categoryGroups.KPI,
        reportCategories.RECEPTACLE,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptaclesInPredesNotInCarditSummary
      ),
      RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS: new ReportDefinitionModel(
        "RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.RECEPTACLE,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptaclesInPredesNotInCarditDetails
      ),
      INTERCHANGE_DETAILS: new ReportDefinitionModel(
        "INTERCHANGE_DETAILS",
        reportTypes.A,
        categoryGroups.EDI_MESSAGES,
        reportCategories.EDI_MESSAGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.interchangePreparationWithAllPickers,
        scSets.SC_1_2_3_60,
        apiFetchInterchangeDetails
      ),
      PRECON_RESCON_CONSIGNMENTS_SUMMARY: new ReportDefinitionModel(
        "PRECON_RESCON_CONSIGNMENTS_SUMMARY",
        reportTypes.B,
        categoryGroups.IRREGULARITIES,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_21,
        apiFetchPreconResconConsignmentsSummary
      ),
      PRECON_RESCON_CONSIGNMENTS_DETAILS: new ReportDefinitionModel(
        "PRECON_RESCON_CONSIGNMENTS_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_21,
        apiFetchPreconResconConsignmentsDetails
      ),
      INTERCHANGE_PROCESSING_SUMMARY: new ReportDefinitionModel(
        "INTERCHANGE_PROCESSING_SUMMARY",
        reportTypes.B,
        categoryGroups.EDI_MESSAGES,
        reportCategories.EDI_MESSAGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.onNetworkDate,
        scSets.SC_1_2_3_60,
        apiFetchInterchangeProcessingSummary
      ),
      INTERCHANGE_PROCESSING_DETAILS: new ReportDefinitionModel(
        "INTERCHANGE_PROCESSING_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.EDI_MESSAGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.onNetworkDate,
        scSets.SC_1_2_3_60,
        apiFetchInterchangeProcessingDetails
      ),
      INTREF_SEQUENCE_VERIFICATION: new ReportDefinitionModel(
        "INTREF_SEQUENCE_VERIFICATION",
        reportTypes.A,
        categoryGroups.EDI_COMPLIANCE,
        reportCategories.EDI_MESSAGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.interchangePreparationWithAllPickers,
        scSets.SC_1_2_3_60,
        apiFetchIntrefSequenceVerification
      ),
      CARDIT_RESDIT_INTERCHANGES: new ReportDefinitionModel(
        "CARDIT_RESDIT_INTERCHANGES",
        reportTypes.A,
        categoryGroups.EDI_MESSAGES,
        reportCategories.EDI_MESSAGE,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_21,
        apiFetchCarditResditInterchanges
      ),
      CONSIGNMENT_RESPONSE_ANALYSIS: new ReportDefinitionModel(
        "CONSIGNMENT_RESPONSE_ANALYSIS",
        reportTypes.A,
        categoryGroups.CONSIGNMENT,
        reportCategories.MONITORING,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_21_70,
        apiFetchConsignmentResponseAnalysis
      ),
      CONSIGNMENT_PARTICULARS: new ReportDefinitionModel(
        "CONSIGNMENT_PARTICULARS",
        reportTypes.a,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_21_70,
        apiFetchConsignmentParticulars
      ),
      CONSIGNMENT_RECEPTACLE_DETAILS: new ReportDefinitionModel(
        "CONSIGNMENT_RECEPTACLE_DETAILS",
        reportTypes.A,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_21_70,
        apiFetchConsignmentReceptacleDetails
      ),
      MRD_XML_ANALYSIS: new ReportDefinitionModel(
        "MRD_XML_ANALYSIS",
        reportTypes.A,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.postalScanDate,
        scSets.SC_1_2_3_80,
        apiFetchMrdXmlAnalysis
      ),
      HANDOVER_REGISTRATION_AT_ORIGIN: new ReportDefinitionModel(
        "HANDOVER_REGISTRATION_AT_ORIGIN",
        reportTypes.A,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.handoverRegistrationTime,
        scSets.SC_1_2_3_80,
        apiFetchHandoverRegistrationAtOrigin
      ),
      OPERATIONAL_ANALYSIS: new ReportDefinitionModel(
        "OPERATIONAL_ANALYSIS",
        reportTypes.A,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.handoverRegistrationTime,
        scSets.SC_1_2_3_80_mrdHandlerId,
        apiFetchOperationalAnalysis
      ),
      OPERATIONAL_ANALYSIS_DAILY: new ReportDefinitionModel(
        "OPERATIONAL_ANALYSIS_DAILY",
        reportTypes.A,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.handoverRegistrationTime,
        scSets.SC_1_2_3_80,
        apiFetchOperationalAnalysisDaily
      ),
      MRD_POD_OVERVIEW: new ReportDefinitionModel(
        "MRD_POD_OVERVIEW",
        reportTypes.A,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.mrdPodOverview,
        scSets.SC_1_2_3_mrd,
        apiFetchMrdPodOverview
      ),
      MRD_XML_DAILY_ANALYSIS: new ReportDefinitionModel(
        "MRD_XML_DAILY_ANALYSIS",
        reportTypes.A,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.postalScanDate,
        scSets.SC_1_2_3_80,
        apiFetchMrdXmlDailyAnalysis
      ),
      CARDIT_NESTING_CARRIER: new ReportDefinitionModel(
        "CARDIT_NESTING_CARRIER",
        reportTypes.D,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchCarditNestingCarrier
      ),
      CARDIT_NESTING_LOCATION: new ReportDefinitionModel(
        "CARDIT_NESTING_LOCATION",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchCarditNestingLocation
      ),
      CARDIT_NESTING_DETAILS: new ReportDefinitionModel(
        "CARDIT_NESTING_DETAILS",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchCarditNestingDetails
      ),
      SAINT_PIERRE_ET_MIQUELON_SUMMARY: new ReportDefinitionModel(
        "SAINT_PIERRE_ET_MIQUELON_SUMMARY",
        reportTypes.B,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.carditFirstLegPlannedDepartureDate,
        scSets.SC_1_2_3,
        apiFetchSaintPierreEtMiquelonSummary
      ),
      SAINT_PIERRE_ET_MIQUELON_DETAILS: new ReportDefinitionModel(
        "SAINT_PIERRE_ET_MIQUELON_DETAILS",
        reportTypes.B,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.carditFirstLegPlannedDepartureDate,
        scSets.SC_1_2_3,
        apiFetchSaintPierreEtMiquelonDetails
      ),
      CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_106: new ReportDefinitionModel(
        "CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_106",
        reportTypes.A,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchCarditResditBestPracticeElements
      ),
      RESDIT_74_21_PERFORMANCE_CARRIER_107B: new ReportDefinitionModel(
        "RESDIT_74_21_PERFORMANCE_CARRIER_107B",
        reportTypes.D,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchResdit7421PerformanceCarrier
      ),
      RESDIT_74_21_PERFORMANCE_LOCATION_107B: new ReportDefinitionModel(
        "RESDIT_74_21_PERFORMANCE_LOCATION_107B",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchResdit7421PerformanceLocation
      ),
      RESDIT_74_21_PERFORMANCE_DETAILS_107B: new ReportDefinitionModel(
        "RESDIT_74_21_PERFORMANCE_DETAILS_107B",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchResdit7421PerformanceDetails
      ),
      CARDIT_CRITICAL_ELEMENTS_CARRIER: new ReportDefinitionModel(
        "CARDIT_CRITICAL_ELEMENTS_CARRIER",
        reportTypes.D,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchCarditCriticalElementsCarrier
      ),
      CARDIT_CRITICAL_ELEMENTS_LOCATION: new ReportDefinitionModel(
        "CARDIT_CRITICAL_ELEMENTS_LOCATION",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchCarditCriticalElementsLocation
      ),
      CARDIT_CRITICAL_ELEMENTS_DETAILS: new ReportDefinitionModel(
        "CARDIT_CRITICAL_ELEMENTS_DETAILS",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11T_30,
        apiFetchCarditCriticalElementsDetails
      ),
      RESDIT_74_21_PERFORMANCE_OPERATOR_802: new ReportDefinitionModel(
        "RESDIT_74_21_PERFORMANCE_OPERATOR_802",
        reportTypes.D,
        categoryGroups.CARRIER,
        reportCategories.CARRIER,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierResdit7421PerformanceOperator
      ),
      RESDIT_74_21_PERFORMANCE_LOCATION_802: new ReportDefinitionModel(
        "RESDIT_74_21_PERFORMANCE_LOCATION_802",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CARRIER,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierResdit7421PerformanceLocation
      ),
      RESDIT_74_21_PERFORMANCE_DETAILS_802: new ReportDefinitionModel(
        "RESDIT_74_21_PERFORMANCE_DETAILS_802",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CARRIER,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierResdit7421PerformanceDetails
      ),
      CARDIT_NESTING_OPERATOR_801: new ReportDefinitionModel(
        "CARDIT_NESTING_OPERATOR_801",
        reportTypes.D,
        categoryGroups.CARRIER,
        reportCategories.CARRIER,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierNestingOperator
      ),
      CARDIT_NESTING_LOCATION_801: new ReportDefinitionModel(
        "CARDIT_NESTING_LOCATION_801",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CARRIER,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierNestingLocation
      ),
      CARDIT_NESTING_DETAILS_801: new ReportDefinitionModel(
        "CARDIT_NESTING_DETAILS_801",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CARRIER,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierNestingDetails
      ),
      CARDIT_TIMELINESS_ANALYSIS: new ReportDefinitionModel(
        "CARDIT_TIMELINESS_ANALYSIS",
        reportTypes.A,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA,
        apiFetchCarditTimelinessAnalysis
      ),
      CARDIT_CRITICAL_ELEMENTS_800_OPERATOR: new ReportDefinitionModel(
        "CARDIT_CRITICAL_ELEMENTS_800_OPERATOR",
        reportTypes.D,
        categoryGroups.CARRIER,
        reportCategories.CONSIGNMENT,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierM39ComplianceOperator
      ),
      CARDIT_CRITICAL_ELEMENTS_800_LOCATION: new ReportDefinitionModel(
        "CARDIT_CRITICAL_ELEMENTS_800_LOCATION",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CONSIGNMENT,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierM39ComplianceLocation
      ),
      CARDIT_CRITICAL_ELEMENTS_800_DETAILS: new ReportDefinitionModel(
        "CARDIT_CRITICAL_ELEMENTS_800_DETAILS",
        reportTypes.D,
        categoryGroups.NO_GROUP,
        reportCategories.CONSIGNMENT,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierM39ComplianceDetails
      ),
      CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY:
        new ReportDefinitionModel(
          "CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY",
          reportTypes.D,
          categoryGroups.HANDLER,
          reportCategories.HANDLER,
          [directionTypes.INBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.handoverRegistrationDate,
          scSets.SC_1_2_3_90,
          apiFetchCarrierMailRegistrationDeviceDeliverySummary
        ),
      CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE:
        new ReportDefinitionModel(
          "CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE",
          reportTypes.D,
          categoryGroups.HANDLER,
          reportCategories.HANDLER,
          [directionTypes.INBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.handoverRegistrationDate,
          scSets.SC_1_2_3_90,
          apiFetchCarrierMailRegistrationDeviceDeliveryCarrierPerformance
        ),
      CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS:
        new ReportDefinitionModel(
          "CARRIER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS",
          reportTypes.D,
          categoryGroups.HANDLER,
          reportCategories.HANDLER,
          [directionTypes.INBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.handoverRegistrationDate,
          scSets.SC_1_2_3_90,
          apiFetchCarrierMailRegistrationDeviceDeliveryDetails
        ),
      CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_804: new ReportDefinitionModel(
        "CARDIT_RESDIT_BEST_PRACTICE_ELEMENTS_804",
        reportTypes.A,
        categoryGroups.CARRIER,
        reportCategories.CARRIER,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.carditConsignmentCompletionDate,
        scSets.SC_1_2_3_11NA_90_30,
        apiFetchCarrierCarditResditBestPracticeElements
      ),
      HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY:
        new ReportDefinitionModel(
          "HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY",
          reportTypes.D,
          categoryGroups.CARRIER,
          reportCategories.CARRIER,
          [directionTypes.INBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.handoverRegistrationDate,
          scSets.SC_1_2_3_91,
          apiFetchHandlerMailRegistrationDeviceDeliverySummary
        ),
      HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE:
        new ReportDefinitionModel(
          "HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE",
          reportTypes.D,
          categoryGroups.CARRIER,
          reportCategories.CARRIER,
          [directionTypes.INBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.handoverRegistrationDate,
          scSets.SC_1_2_3_91,
          apiFetchHandlerMailRegistrationDeviceDeliveryCarrierPerformance
        ),
      HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS:
        new ReportDefinitionModel(
          "HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS",
          reportTypes.D,
          categoryGroups.CARRIER,
          reportCategories.CARRIER,
          [directionTypes.INBOUND],
          locationTypes.IMPC,
          productTypes.MAIL_SUBCLASS,
          PeriodSelectionConstants.handoverRegistrationDate,
          scSets.SC_1_2_3_91,
          apiFetchHandlerMailRegistrationDeviceDeliveryDetails
        ),
      CARDIT_BY_RECEIVING_AIRLINE: new ReportDefinitionModel(
        "CARDIT_BY_RECEIVING_AIRLINE",
        reportTypes.A,
        categoryGroups.EDI_EXCHANGE,
        reportCategories.CARDIT,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3,
        apiFetchCarditByReceivingAirline
      ),
      CARDIT_BY_RECEIVING_AIRLINE_NUMBERED: new ReportDefinitionModel(
        "CARDIT_BY_RECEIVING_AIRLINE_NUMBERED",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.EDI_EXCHANGE,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3,
        apiFetchCarditByReceivingAirlineNumbered
      ),
      CARDIT_BY_SENDING_POST: new ReportDefinitionModel(
        "CARDIT_BY_SENDING_POST",
        reportTypes.A,
        categoryGroups.EDI_EXCHANGE,
        reportCategories.CARDIT,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3,
        apiFetchCarditBySendingPostSigned
      ),
      CARDIT_BY_SENDING_POST_NUMBERED: new ReportDefinitionModel(
        "CARDIT_BY_SENDING_POST_NUMBERED",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.EDI_EXCHANGE,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3,
        apiFetchCarditBySendingPostNumbered
      ),
      RESDIT_BY_RECEIVING_POST: new ReportDefinitionModel(
        "RESDIT_BY_RECEIVING_POST",
        reportTypes.A,
        categoryGroups.EDI_EXCHANGE,
        reportCategories.CARDIT,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3,
        apiFetchResditByReceivingPostSigned
      ),
      RESDIT_BY_RECEIVING_POST_NUMBERED: new ReportDefinitionModel(
        "RESDIT_BY_RECEIVING_POST_NUMBERED",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.EDI_EXCHANGE,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3,
        apiFetchResditByReceivingPostNumbered
      ),
      RESDIT_BY_SENDING_AIRLINE: new ReportDefinitionModel(
        "RESDIT_BY_SENDING_AIRLINE",
        reportTypes.A,
        categoryGroups.EDI_EXCHANGE,
        reportCategories.CARDIT,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3,
        apiFetchResditBySendingAirline
      ),
      RESDIT_BY_SENDING_AIRLINE_NUMBERED: new ReportDefinitionModel(
        "RESDIT_BY_SENDING_AIRLINE_NUMBERED",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.CARDIT,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3,
        apiFetchResditBySendingAirlineNumbered
      ),
      TRANSPORT_EXCEPTIONS: new ReportDefinitionModel(
        "TRANSPORT_EXCEPTIONS",
        reportTypes.A,
        categoryGroups.DESPATCH,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchParticularsPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchTransportExceptions
      ),
      RECEPTACLE_TRANSPORT_OVERVIEW: new ReportDefinitionModel(
        "RECEPTACLE_TRANSPORT_OVERVIEW",
        reportTypes.A,
        categoryGroups.MONITORING,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.receptacleTransportMonitoringOverview,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptacleTransportOverview
      ),
      RECEPTACLE_OVERVIEW: new ReportDefinitionModel(
        "RECEPTACLE_OVERVIEW",
        reportTypes.A,
        categoryGroups.MONITORING,
        reportCategories.RECEPTACLE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.receptacleTransportMonitoringOverview,
        scSets.SC_1_2_3_10_30,
        apiFetchReceptacleOverview,
        undefined,
        true
      ),
      CARDIT_LINK_TRACE: new ReportDefinitionModel(
        "CARDIT_LINK_TRACE",
        reportTypes.A,
        categoryGroups.CARDIT,
        reportCategories.CARDIT,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_21,
        apiFetchCarditLinkTrace
      ),
      HANDLER_MONITORING: new ReportDefinitionModel(
        "HANDLER_MONITORING",
        reportTypes.A,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CLASS,
        PeriodSelectionConstants.mrdHandoverRegistrationDate,
        scSets.SC_1_2_3,
        apiFetchHandlerMonitoring
      ),
      CARRIER_ANALYSIS_411: new ReportDefinitionModel(
        "CARRIER_ANALYSIS_411",
        reportTypes.A,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.mrdHandoverRegistrationDate,
        scSets.SC_1_2_3,
        apiFetchCarrierAnalysis
      ),
      CARDIT_RESDIT_EVENT_OVERVIEW_105: new ReportDefinitionModel(
        "CARDIT_RESDIT_EVENT_OVERVIEW_105",
        reportTypes.A,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.consignmentCompletionDate,
        scSets.SC_1_2_3_21,
        apiFetchCarditResditEventOverview
      ),
      PAPER_FREE_MONITORING_POST_900_SUMMARY: new ReportDefinitionModel(
        "PAPER_FREE_MONITORING_POST_900_SUMMARY",
        reportTypes.B,
        categoryGroups.PAPER_FREE,
        reportCategories.PAPER_FREE,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3,
        apiFetchPaperFreeMonitoringPostSummary
      ),
      PAPER_FREE_MONITORING_POST_900_DETAILS: new ReportDefinitionModel(
        "PAPER_FREE_MONITORING_POST_900_DETAILS",
        reportTypes.B,
        categoryGroups.PAPER_FREE,
        reportCategories.PAPER_FREE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3,
        apiFetchPaperFreeMonitoringPostDetails
      ),
      RESDES_MANAGEMENT_SUMMARY_EPG: new ReportDefinitionModel(
        "RESDES_MANAGEMENT_SUMMARY_EPG",
        reportTypes.A,
        categoryGroups.EPG,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.epgDespatchClosedPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchResdesManagementSummaryEpg
      ),
      PAPER_FREE_MONITORING_CARRIER_901_SUMMARY: new ReportDefinitionModel(
        "PAPER_FREE_MONITORING_CARRIER_901_SUMMARY",
        reportTypes.B,
        categoryGroups.PAPER_FREE,
        reportCategories.PAPER_FREE,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3,
        apiFetchPaperFreeMonitoringCarrierSummary
      ),
      PAPER_FREE_MONITORING_CARRIER_901_DETAILS: new ReportDefinitionModel(
        "PAPER_FREE_MONITORING_CARRIER_901_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.PAPER_FREE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3,
        apiFetchPaperFreeMonitoringCarrierDetails
      ),
      PAPER_FREE_MONITORING_CARRIER_903_SUMMARY: new ReportDefinitionModel(
        "PAPER_FREE_MONITORING_CARRIER_903_SUMMARY",
        reportTypes.B,
        categoryGroups.CARRIER,
        reportCategories.PAPER_FREE,
        [directionTypes.INBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3,
        apiFetchCarrierPaperFreeMonitoringSummary
      ),
      PAPER_FREE_MONITORING_CARRIER_903_DETAILS: new ReportDefinitionModel(
        "PAPER_FREE_MONITORING_CARRIER_903_DETAILS",
        reportTypes.B,
        categoryGroups.NO_GROUP,
        reportCategories.PAPER_FREE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3,
        apiFetchCarrierPaperFreeMonitoringDetails
      ),
      PAPER_FREE_MONITORING_POST_902_SUMMARY: new ReportDefinitionModel(
        "PAPER_FREE_MONITORING_POST_902_SUMMARY",
        reportTypes.B,
        categoryGroups.CARRIER,
        reportCategories.PAPER_FREE,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3,
        apiFetchCarrierPaperFreeMonitoringPostSummary
      ),
      PAPER_FREE_MONITORING_POST_902_DETAILS: new ReportDefinitionModel(
        "PAPER_FREE_MONITORING_POST_902_DETAILS",
        reportTypes.B,
        categoryGroups.CARRIER,
        reportCategories.PAPER_FREE,
        [directionTypes.INBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3,
        apiFetchCarrierPaperFreeMonitoringPostDetails
      ),
      EPG_LINK_BY_LINK_REPORT_013: new ReportDefinitionModel(
        "EPG_LINK_BY_LINK_REPORT_013",
        reportTypes.A,
        categoryGroups.EPG,
        reportCategories.DESPATCH,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.epgLinkByLinkPeriod,
        scSets.SC_1_2_3_10_30,
        apiFetchEpgLinkByLink
      ),
      HANDOVER_ANALYSIS_AT_DESTINATION: new ReportDefinitionModel(
        "HANDOVER_ANALYSIS_AT_DESTINATION",
        reportTypes.A,
        categoryGroups.CONSIGNMENT,
        reportCategories.CONSIGNMENT,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.receptacleTransportMonitoringOverview,
        scSets.SC_1_2_3_10_30,
        apiFetchHandoverAnalysisAtDestination
      ),
      MESSAGE_CAPABILITY_OVERVIEW: new ReportDefinitionModel(
        "MESSAGE_CAPABILITY_OVERVIEW",
        reportTypes.A,
        categoryGroups.EDI_EXCHANGE,
        reportCategories.EDI_EXCHANGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3_11_EDI_EXCHANGE,
        apiFetchMessageCapabilityOverview
      ),
      MESSAGE_PROFILE: new ReportDefinitionModel(
        "MESSAGE_PROFILE",
        reportTypes.A,
        categoryGroups.EDI_EXCHANGE,
        reportCategories.EDI_EXCHANGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.messagePreparationDate,
        scSets.SC_1_2_3_11_EDI_EXCHANGE,
        apiFetchMessageProfile
      ),
      EDI_EXCHANGE_LETTER_706: new ReportDefinitionModel(
        "EDI_EXCHANGE_LETTER_706",
        reportTypes.C,
        categoryGroups.EDI_EXCHANGE,
        reportCategories.EDI_EXCHANGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_11_EDI_EXCHANGE_706,
        apiFetchEdiExchangeLetter
      ),
      EDI_EXCHANGE_PARCEL_706: new ReportDefinitionModel(
        "EDI_EXCHANGE_PARCEL_706",
        reportTypes.C,
        categoryGroups.EDI_EXCHANGE,
        reportCategories.EDI_EXCHANGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_11_EDI_EXCHANGE_706,
        apiFetchEdiExchangeParcel
      ),
      EDI_EXCHANGE_EMS_706: new ReportDefinitionModel(
        "EDI_EXCHANGE_EMS_706",
        reportTypes.C,
        categoryGroups.EDI_EXCHANGE,
        reportCategories.EDI_EXCHANGE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.complianceMismatchPeriod,
        scSets.SC_1_2_3_11_EDI_EXCHANGE_706,
        apiFetchEdiExchangeEms
      ),
      TRAY_USAGE_940: new ReportDefinitionModel(
        "TRAY_USAGE_940",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.period,
        scSets.SC_1_2_3_10,
        apiFetchIpcTrayUsage
      ),
      MIXED_TRAY_USAGE_942: new ReportDefinitionModel(
        "MIXED_TRAY_USAGE_942",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.period,
        scSets.SC_1_2_3_10,
        apiFetchMixedTrayUsage
      ),
      BAG_USAGE_950: new ReportDefinitionModel(
        "BAG_USAGE_950",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.period,
        scSets.SC_1_2_3_10,
        apiFetchBagUsage
      ),
      PALLET_BOX_USAGE_960: new ReportDefinitionModel(
        "PALLET_BOX_USAGE_960",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.period,
        scSets.SC_1_2_3_10,
        apiFetchPalletBoxUsage
      ),
      COMPARATIVE_TRAY_USAGE_941: new ReportDefinitionModel(
        "COMPARATIVE_TRAY_USAGE_941",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.baseDateRange,
        scSets.SC_1_2_3_10_COMPARATIVE,
        apiFetchComparativeTrayUsage
      ),
      COMPARATIVE_BAG_USAGE_951: new ReportDefinitionModel(
        "COMPARATIVE_BAG_USAGE_951",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.baseDateRange,
        scSets.SC_1_2_3_10_COMPARATIVE,
        apiFetchComparativeBagUsage
      ),
      COMPARATIVE_PALLET_BOX_USAGE_961: new ReportDefinitionModel(
        "COMPARATIVE_PALLET_BOX_USAGE_961",
        reportTypes.A,
        categoryGroups.NO_GROUP,
        reportCategories.IPC_EQUIPMENT_POOLS,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.baseDateRange,
        scSets.SC_1_2_3_10_COMPARATIVE,
        apiFetchComparativePalletBoxUsage
      ),
      RECEPTACLE_POD_PERFORMANCE_404_SUMMARY: new ReportDefinitionModel(
        "RECEPTACLE_POD_PERFORMANCE_404_SUMMARY",
        reportTypes.B,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.eventDate,
        scSets.SC_1_2_3,
        apiFetchReceptaclePodPerformanceSummary
      ),
      RECEPTACLE_POD_PERFORMANCE_404_DETAILS: new ReportDefinitionModel(
        "RECEPTACLE_POD_PERFORMANCE_404_DETAILS",
        reportTypes.B,
        categoryGroups.MRD,
        reportCategories.MRD,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.baseDateRange,
        scSets.SC_1_2_3,
        apiFetchReceptaclePodPerformanceDetails
      ),
      CAPE_USAGE_MONITORING_1000: new ReportDefinitionModel(
        "CAPE_USAGE_MONITORING_1000",
        reportTypes.C,
        categoryGroups.USER_MONITORING,
        reportCategories.USER_MONITORING,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.reportGenerationDate,
        scSets.SC_1_2_3_50_51,
        apiFetchCapeUsageMonitoring
      ),
      CAPE_USAGE_MONITORING_BY_OPERATOR_1000: new ReportDefinitionModel(
        "CAPE_USAGE_MONITORING_BY_OPERATOR_1000",
        reportTypes.C,
        categoryGroups.NO_GROUP,
        reportCategories.USER_MONITORING,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.reportGenerationDate,
        scSets.SC_1_2_3_50_51,
        apiFetchCapeUsageMonitoringByOperator
      ),
      CAPE_USAGE_MONITORING_BY_OPERATOR_USER_1000: new ReportDefinitionModel(
        "CAPE_USAGE_MONITORING_BY_OPERATOR_USER_1000",
        reportTypes.C,
        categoryGroups.NO_GROUP,
        reportCategories.USER_MONITORING,
        [directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_CATEGORY,
        PeriodSelectionConstants.reportGenerationDate,
        scSets.SC_1_2_3_50_51,
        apiFetchCapeUsageMonitoringByUser
      ),
      ITEM_OVERVIEW_V1_200: new ReportDefinitionModel(
        "ITEM_OVERVIEW_V1_200",
        reportTypes.C,
        categoryGroups.ITEM,
        reportCategories.ITEM,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.entryDate,
        scSets.SC_1_2_3_100_OVERVIEW_11_OVERVIEW_30,
        apiFetchItemOverviewV1
      ),
      ITEM_OVERVIEW_V2_201: new ReportDefinitionModel(
        "ITEM_OVERVIEW_V2_201",
        reportTypes.C,
        categoryGroups.ITEM,
        reportCategories.ITEM,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.entryDate,
        scSets.SC_1_2_3_100_OVERVIEW_11_OVERVIEW_30,
        apiFetchItemOverviewV2
      ),
      ITEM_OVERVIEW_DETAILS_200: new ReportDefinitionModel(
        "ITEM_OVERVIEW_DETAILS_200",
        reportTypes.C,
        categoryGroups.ITEM,
        reportCategories.ITEM,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.OPERATOR,
        productTypes.MAIL_CLASS,
        PeriodSelectionConstants.entryDate,
        scSets.SC_1_2_3_100_10_30,
        apiFetchItemOverviewDetails
      ),
      THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY: new ReportDefinitionModel(
        "THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY",
        reportTypes.B,
        categoryGroups.CERTIFICATION,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchPlannedArrivalDate,
        scSets.SC_1_2_3_10_30,
        apiFetchThresholdsForCertificationSummary
      ),
      THRESHOLDS_FOR_CERTIFICATION_545_DETAILS: new ReportDefinitionModel(
        "THRESHOLDS_FOR_CERTIFICATION_545_DETAILS",
        reportTypes.B,
        categoryGroups.CERTIFICATION,
        reportCategories.COMPLIANCE,
        [directionTypes.INBOUND, directionTypes.OUTBOUND],
        locationTypes.IMPC,
        productTypes.MAIL_SUBCLASS,
        PeriodSelectionConstants.despatchPlannedArrivalDate,
        scSets.SC_1_2_3_10_30,
        apiFetchThresholdsForCertificationDetails
      ),
    };
  }

  setSelectionCriteria(name, instance) {
    if (!this.defaults[name]) {
      throw new Error(`No report definition for '${name}'.`);
    }

    this.defaults[name].selectionCriteria = instance;
  }

  get() {
    return this.defaults;
  }
}
export const Reports = new ReportDefinitions();
export const applySelectionCriteriaBasedOnUser = (userType) => {
  if (userType && userType.includes("C")) {
    Reports.setSelectionCriteria("CARDIT_TIMELINESS_ANALYSIS", scSets.SC_1_2_3);
  } else {
    Reports.setSelectionCriteria(
      "CARDIT_TIMELINESS_ANALYSIS",
      scSets.SC_1_2_3_11NA
    );
  }
};

export default Reports.get();
